import { environment as baseEnv } from './environment.dev'

export const environment = {
  ...baseEnv,
  apiUrl: 'https://dev-alt-10-api.eshyft.com/api/v2',
  socketUrl: 'https://dev-alt-10-api.eshyft.com',
  firebaseTenantId: 'dev-alt-10-qx5lu',
}
